/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import {
	InspectorControls,
	BlockControls,
	RichText,
	useBlockProps,
} from '@wordpress/block-editor';
import { ToolbarButton, ToolbarGroup } from '@wordpress/components';

import { useState, Fragment, useEffect } from '@wordpress/element';
import { useInstanceId } from '@wordpress/compose';
import classNames from 'classnames';

import { OptionsModal } from './modal';
import Settings from '../form-input/settings';

export default function Edit( props ) {
	const { attributes, setAttributes } = props;
	const {
		name,
		options,
		showHelp,
		help,
		readonly,
		multiple,
		disabled,
		hidden,
		label,
		required,
		id,
	} = attributes;
	const instanceId = useInstanceId( Edit );

	const [ isModalOpen, setModalOpen ] = useState( false );

	useEffect( () => {
		if ( ! id ) {
			setAttributes( { id: 'popper-select-' + instanceId } );
		}
	}, [] );

	const blockProps = useBlockProps( {
		className: classNames( {
			'missing-name': ! name,
		} ),
	} );

	const selectedOpts = () => {
		const selection = options
			.filter( ( x ) => true === x.selected )
			.map( ( x ) => x.value );
		if ( ! multiple ) {
			return selection[ 0 ];
		}
		return selection;
	};

	return (
		<div { ...blockProps }>
			<Settings { ...props } />
			<InspectorControls>
				<BlockControls>
					<ToolbarGroup>
						<ToolbarButton
							label={ __( 'Add options', 'formello' ) }
							icon={ 'editor-ul' }
							onClick={ () => {
								setModalOpen( true );
							} }
						/>
					</ToolbarGroup>
				</BlockControls>
			</InspectorControls>
			<Fragment>
				<label hidden={ hidden } htmlFor={ instanceId }>
					<RichText
						tagName="span"
						value={ label }
						onChange={ ( newLabel ) =>
							setAttributes( { label: newLabel } )
						}
						aria-label={
							label ? __( 'Label' ) : __( 'Empty label' )
						}
						data-empty={ label ? false : true }
						placeholder={ __( 'Type the label for this input' ) }
					/>
					{ required && <span className="required">*</span> }
				</label>
				<select
					id={ instanceId }
					name={ name }
					multiple={ multiple }
					readOnly={ readonly }
					disabled={ disabled }
					defaultValue={ selectedOpts() }
				>
					{ options.map( ( opt, index ) => {
						return (
							<option
								value={ opt.value || opt.label }
								key={ index }
								//selected={ opt.selected }
							>
								{ opt.label }
							</option>
						);
					} ) }
				</select>
				{ showHelp && (
					<RichText
						tagName="small"
						value={ help }
						onChange={ ( val ) => setAttributes( { val } ) }
						placeholder={ __( 'Enter help message…', 'formello' ) }
						allowedFormats={ [
							'core/bold',
							'core/italic',
							'core/link',
						] }
					/>
				) }
			</Fragment>
			{ isModalOpen && (
				<OptionsModal
					{ ...props }
					onRequestClose={ () => {
						setModalOpen( false );
					} }
				/>
			) }
		</div>
	);
}
